import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface DeliveryTestingDraft {
  releaseType: string;
  environment: string;
  testFocus: string;
}

@Component({
  selector: 'app-testing',
  templateUrl: './testing.page.html',
  styleUrls: ['./testing.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class TestingPage {
  public testingSuggestions: any[] = [
    { icon: 'bi bi-play', prompt: 'Run all unit tests' },
    { icon: 'bi bi-clipboard2-check', prompt: 'Show the last test run summary' },
    { icon: 'bi bi-graph-up', prompt: 'List flaky tests' },
  ];

  public testingContext: any = {
    page: 'testing',
    purpose: 'Assist with tests, coverage, flakiness and CI feedback',
    suites: [],
    recentRuns: [],
    coverageTargets: {},
    flakyTests: [],
    outputs: ['Test run summary', 'Coverage deltas', 'Flaky test candidates']
  };

  public checkingReadiness = false;
  public testingError = '';
  public testingSuccess = '';
  public hasCheckedReadiness = false;
  public deliveryTestingDraft: DeliveryTestingDraft = {
    releaseType: '',
    environment: '',
    testFocus: '',
  };

  public readonly releaseTypeOptions = ['Hotfix', 'Minor release', 'Major release'];
  public readonly environmentOptions = ['Staging', 'Pre-production', 'Production canary'];

  constructor() {}

  public async runDeliveryReadinessCheck(): Promise<void> {
    this.testingError = '';
    this.testingSuccess = '';
    this.hasCheckedReadiness = false;

    if (!this.deliveryTestingDraft.releaseType.trim()) {
      this.testingError = 'Select a release type before running delivery readiness.';
      return;
    }
    if (!this.deliveryTestingDraft.environment.trim()) {
      this.testingError = 'Select an environment before running delivery readiness.';
      return;
    }

    this.checkingReadiness = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasCheckedReadiness = true;
      this.testingSuccess = 'Delivery readiness check completed for selected release scope.';
    } finally {
      this.checkingReadiness = false;
    }
  }
} 